import {
  useAvailableIntegrations,
  useGetIntegrationStatus
} from '@/application/queries/use-integrations'
import InstalledAppCard from '../../components/integration-components/installed-app-card'

interface InstalledIntegrationsProps {
  category: string
  searchQuery: string
}
export const InstalledIntegrations: React.FC<InstalledIntegrationsProps> = ({
  category,
  searchQuery
}) => {
  const { data: integrations, status } = useAvailableIntegrations()

  const {
    integrationStatusData,
    isLoading: isLoadingStatuses,
    error
  } = useGetIntegrationStatus()

  const installedIntegrations = integrations?.filter(
    (integration) =>
      integrationStatusData?.find((integrationStatus) => {
        return integrationStatus.name === integration.integration_name
      })?.status !== 'INTEGRATION_STATUS_INACTIVE'
  )

  if (status === 'pending' || isLoadingStatuses) {
    return <div>Loading installed apps...</div>
  }

  if (error) {
    return <div>Error loading installed apps: {(error as Error).message}</div>
  }

  const filteredIntegrations = installedIntegrations?.filter((integration) => {
    return (
      (category !== 'All'
        ? integration!.integration_category_tags?.includes(
            category.toLocaleLowerCase().replaceAll(' ', '_')
          )
        : true) &&
      integration.integration_name
        ?.toLowerCase()
        .replace(/_/g, ' ')
        .includes(searchQuery.toLocaleLowerCase())
    )
  })

  return (
    <div className="mb-20">
      {(filteredIntegrations ?? []).length === 0 ? (
        <div className="mt-20 flex size-full items-center justify-center">
          <p className="text-sm text-neutral-400">
            {installedIntegrations?.length === 0
              ? "You don't have any integrations installed yet"
              : 'No installed integrations found'}
          </p>
        </div>
      ) : (
        (filteredIntegrations ?? []).map((integration) => (
          <InstalledAppCard
            key={integration.integration_id}
            integration={integration}
          />
        ))
      )}
    </div>
  )
}

export default InstalledIntegrations
